export const selectIncidentTacticsLoading = (state) => state.mitre.loading;
export const selectIncidentTacticsLoadingId = (state) => state.mitre.incidentId;
export const selectIncidentTactics = (state) => state.mitre.tactics;
